
import React from 'react';
import { Accordion } from '@/components/ui/accordion';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { FaqItem } from './FaqItem';
import { Faq } from '@/lib/supabase/products';

interface FaqsListProps {
  faqs: Faq[];
  updateFaq: (id: string, field: keyof Faq, value: any) => void;
  removeFaq: (id: string) => void;
  toggleVisibility: (id: string) => void;
  addNewFaq: () => void;
}

export const FaqsList = ({ 
  faqs, 
  updateFaq, 
  removeFaq, 
  toggleVisibility, 
  addNewFaq 
}: FaqsListProps) => {
  if (faqs.length === 0) {
    return (
      <div className="py-8 text-center text-gray-500 dark:text-gray-400">
        <p>Aucune FAQ ajoutée</p>
        <p className="text-sm">Ajoutez des questions fréquentes pour aider vos clients</p>
        <Button onClick={addNewFaq} className="w-full mt-4" variant="outline">
          <Plus className="h-4 w-4 mr-2" />
          Ajouter une FAQ
        </Button>
      </div>
    );
  }

  return (
    <>
      <Accordion type="multiple" className="space-y-2">
        {faqs.map((faq) => (
          <FaqItem
            key={faq.id}
            faq={faq}
            updateFaq={updateFaq}
            removeFaq={removeFaq}
            toggleVisibility={toggleVisibility}
          />
        ))}
      </Accordion>

      <Button 
        onClick={addNewFaq} 
        className="w-full mt-4 bg-[#1e1e2d] text-white dark:bg-[#1e1e2d] dark:text-white border dark:border-gray-700 hover:bg-[#252a41] dark:hover:bg-[#252a41]"
      >
        <Plus className="h-4 w-4 mr-2" />
        Ajouter une FAQ
      </Button>
    </>
  );
};
